<template>
    <toolbar-option>
        <template slot="primary">
            <button class="button" @click="showModal('modal-input-options')">
                MANAGE
            </button>

            <label for="inputAutoSubmit" class="checkbox">
                <input
                    id="inputAutoSubmit"
                    v-model="autoSubmit"
                    type="checkbox"
                    true-value="true"
                    false-value="no"
                >
                Submit on Select

                <tooltip>
                    The form will automatically submit as soon as an option is selected.
                </tooltip>
            </label>
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import { SHOW_MODAL } from '@/store/types/mutation-types';

export default {
    name: 'input-options',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Dropdown Options',
            value: '',
            autoSubmit: '',
        };
    },

    watch: {
        autoSubmit() {
            this.selectedElements[0].setElementData('selectAutoSubmit', this.autoSubmit);
        },
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}

.checkbox {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    margin-top: 1.5em;

    input {
        position: relative;
        top: 1px;
        margin-right: 0.5em;
    }
}
</style>
